import { StatementType } from './statement-types';

export const GermanStatements: Record<StatementType, string[]> = {
  annoyed: [
    'Es ist ja nicht so, als hätte ich es dir gestern nicht gesagt?',
    'Denk nicht, dass ich nicht aufgepasst habe!',
    'Ich kann bei diesem Krach nicht denken!',
    'Passiv-aggressiv, was?',
    'Du weißt, dass das da nicht hingehört!',
    'Es sind 7 Stunden und 15 Tage vergangen, seit du meinen Rasenmäher geliehen hast!',
    'Musst du so laut kauen?',
    'Nimm es doch einfach!',
    'Wenn du nichts Gutes zu sagen hast, sag gar nichts!',
    'Lass uns endlich gehen.',
  ],
  frustrated: [
    'Na schön, dann eben auf deine Art!',
    'Ich werde das nie hinkriegen!',
    'Die Webseite lädt nicht!',
    'Diese Dose geht nicht auf!',
    'So kannst du das nicht aufmachen!',
    'Du musst immer das letzte Wort haben!',
  ],
  angry: [
    'WAS ZUM TEUFEL GLAUBST DU, WAS DU TUST!?',
    'Bastardsohn einer finsteren Viper!',
    'Ich werde dich umbringen!',
    'Nein, du liegst falsch!',
    'Du solltest uns beschützen!',
  ],
  random: [
    'Die Gänse kommen! Die Gänse kommen!',
    'Süßkartoffeln sind weder süß noch Kartoffeln.',
    'Na gut dann! Yalla!',
    'Werden Wunder denn nie aufhören?',
    '"Wow, das sind aber viele Blaubeeren!"',
    'Heiliger Strohsack!',
    'Bist du sicher, dass du das tun willst?',
    'Herr, erbarme dich!',
    'Der Himmel ist heute so blau.',
    'Ich fürchte keine Geister!',
    'Ich schätze, du kannst nicht kochen?',
    'Beruhigen wir uns und atmen tief durch.',
    'Liebe ist die Antwort.',
  ],
  child: [
    'Haha!',
    'Nicht schnell genug!',
    'Oh Mann!',
    'ALT!',
    'hahaha',
    'Wheeee!',
    'Willst du schon aufgeben?',
    'Schau dir das an!',
    'Wirst du müde?',
    'Entschuldigung!',
    'Pass auf!',
  ],
  'child-no': ['Nein!'],
  'stay-near-me': ['Bleib in meiner Nähe, nicht weggehen.'],
};
